import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import {useHistory} from "react-router-dom";
import {isEmail} from "validator";

// Libs
import {useAuth} from "../auth/auth";
import {successColor} from "../common/libs/theme-lib";

// Components
import Button from "../common/components/button";
import TextInput from "../common/components/text-input";

const ForgotPage = () => {

    // hooks
    const auth = useAuth();
    const history = useHistory();
    const to = "/login";

    // i18n
    const {t} = useTranslation("auth");

    // State
    const [email, setEmail] = useState({value: "", isValid: false});
    const [validForm, setValidForm] = useState(false);

    function validateEmail(email) {
        let isValid = !!isEmail(email);
        setEmail({value: email, isValid: isValid});
    }

    function validateForm() {
        email.isValid ? setValidForm(true) : setValidForm(false);
    }

    useEffect(() => {
        validateForm();
    }, [email]);

    return (
        <div style={{
            display: "block",
            margin: "auto"
        }}>
            <h2 style={{fontSize: "18px"}}>{t("forgot.title")}</h2>
            <p>{t("forgot.text")}</p>
            {!!auth.showInputs && (
                <TextInput
                    placeholder={t("login.placeholderEmail")}
                    style={loginItemStyle}
                    value={email.value}
                    setValue={validateEmail}
                    icon={"user"}
                />
            )}
            {!!auth && !!auth.forgotError && (
                <div style={{
                    backgroundColor: "#ffdddd",
                    color: "#ff0000",
                    border: "1px solid #ff0000",
                    borderRadius: 3,
                    fontWeight: "bold",
                    maxWidth: "80%",
                    marginTop: 15,
                    padding: 8
                }}>
                    {auth.forgotError}
                </div>
            )}
            {!!auth && !!auth.forgotSuccess && (
                <div style={{
                    backgroundColor: successColor,
                    color: "#ffffff",
                    border: "1px solid",
                    borderColor: "#ffffff",
                    borderRadius: 3,
                    fontWeight: "bold",
                    maxWidth: "80%",
                    marginTop: 15,
                    padding: 8
                }}>
                    {auth.forgotSuccess}
                </div>
            )}
            <div style={{
                display: "flex",
                marginTop: "15px"
            }}>
                <Button
                    intent="cancel"
                    text={t("forgot.actions.back")}
                    action={() => !!to && history.push(to)}
                    style={{
                        marginRight: "15px",
                    }}
                />
                {!!auth.showInputs && (
                    <Button
                        intent="primary"
                        text={t("forgot.actions.send")}
                        disabled={validForm}
                        action={() => {
                            auth.forgotPassword(email.value);
                            setValidForm(false);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default ForgotPage;

const loginItemStyle = {
    marginTop: 15,
    display: "flex",
    flexDirection: "column",
    width: "100%"
}